import { Button, ColorV2, Modal, Text } from "@adoptaunabuelo/react-components";
import { ProductScheme, SubscriptionScheme } from "client-v2";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { State } from "../../redux";
import { useEffect, useState } from "react";
import media from "styled-media-query";

const DataView = styled.div<{ $type: "low" | "high" }>`
	display: flex;
	flex-direction: column;
	gap: ${(props) => (props.$type === "low" ? "48px" : "32px")};
	padding: 24px 32px 32px;
	align-items: center;
	${media.lessThan("medium")`
		padding: 24px 24px 32px;
	`}
`;
const TextView = styled.div<{ $type: "low" | "high" }>`
	display: flex;
	flex-direction: column;
	gap: ${(props) => (props.$type === "low" ? "16px" : "24px")};
	width: 100%;
	text-align: center;
`;
const TitleView = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;
const ButtonsView = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
`;
const Image = styled.img<{ $type: "low" | "high" }>`
	display: flex;
	height: 232px;
	width: 100%;
	object-fit: cover;
	object-position: ${(props) =>
		props.$type === "low" ? "center 20%" : "center 45%"};
	border-radius: 24px;
	${media.lessThan("medium")`
		padding: 0px;
	`}
`;

const UpdateSubscriptionModal = (props: UpdateSubscriptionModalProps) => {
	const appLocation = useSelector((state: State) => state.location.location);
	const isMobile = useSelector((state: State) => state.screen.isMobile);

	const [currentCurrencyPrice, setCurrentCurrencyPrice] = useState("");
	const [currencyPrice, setCurrencyPrice] = useState("");
	const [type, setType] = useState<"low" | "high">("low");

	useEffect(() => {
		getCurrencyPrice();
		const currentPrice =
			props.subscription.Product.charge === "annually"
				? props.subscription.Product.price / 12
				: props.subscription.Product.charge === "quarterly"
					? props.subscription.Product.price / 3
					: props.subscription.Product.price;
		const newPrice =
			props.product.charge === "annually"
				? props.product.price / 12
				: props.product.charge === "quarterly"
					? props.product.price / 3
					: props.product.price;

		if (newPrice > currentPrice) {
			setType("high");
		} else setType("low");
	}, []);

	const getCurrencyPrice = () => {
		const currency = appLocation
			? appLocation.currency.name.toLocaleUpperCase()
			: "EUR";
		if (props.product.data) {
			const price = props.product.data[currency as any];
			setCurrencyPrice(
				price
					? price.price.toLocaleString("es-ES", {
							useGrouping: true,
						})
					: props.product.price.toLocaleString("es-ES", {
							useGrouping: true,
						}),
			);
		} else {
			setCurrencyPrice(
				props.product.price.toLocaleString("es-ES", {
					useGrouping: true,
				}),
			);
		}
		if (props.subscription.Product.data) {
			const price = props.subscription.Product.data[currency as any];
			setCurrentCurrencyPrice(
				price
					? price.price.toLocaleString("es-ES", {
							useGrouping: true,
						})
					: props.product.price.toLocaleString("es-ES", {
							useGrouping: true,
						}),
			);
		} else {
			setCurrentCurrencyPrice(
				props.subscription.Product.price.toLocaleString("es-ES", {
					useGrouping: true,
				}),
			);
		}
	};

	const getAmountLabel = (price: string) => {
		const symbol = appLocation ? appLocation.currency.symbol : "€";
		const period =
			props.product.charge === "monthly"
				? " al mes"
				: props.product.charge === "annually"
					? " al año"
					: "";
		return `${price} ${symbol}${period}`;
	};

	return (
		<Modal
			isVisible={props.isVisible}
			hideClose={true}
			hideHeader={true}
			type={isMobile ? "full-screen" : "default"}
			style={{ borderRadius: isMobile ? "24px 24px 0px 0px" : 24 }}
			contentStyle={{
				padding: isMobile ? 0 : 4,
				backgroundColor: ColorV2.surface.invert,
			}}
			onClose={props.onClose}
		>
			<Image
				$type={type}
				src={
					type === "low"
						? require("../../assets/images/background/update_sub_01.webp")
						: require("../../assets/images/background/update_sub_02.webp")
				}
			/>
			<DataView $type={type}>
				<TextView $type={type}>
					<TitleView>
						<Text
							type="h3"
							weight="semibold"
							style={{
								textAlign: "center",
								color: ColorV2.text.neutralHard,
							}}
						>
							{type === "low"
								? `Ya colaboras con nosotros con ${getAmountLabel(
										currentCurrencyPrice,
									)}`
								: "Vas a aumentar tu donación"}
						</Text>
						<Text
							type="p"
							style={{
								textAlign: "center",
								color: ColorV2.text.neutralHard,
							}}
						>
							{type === "low"
								? "Si quieres aumentar tu donación selecciona una cantidad superior y la actualizaremos automáticamente."
								: "Te agradecemos que quieras aumentar tu donación, este gesto nos ayuda a seguir acompañando a más personas mayores."}
						</Text>
					</TitleView>
					{type === "high" && (
						<Text
							type="c2"
							style={{
								textAlign: "center",
								color: ColorV2.text.neutralMedium,
							}}
						>
							No se te cobrará nada ahora. El nuevo importe se
							aplicará en tu próximo recibo.
						</Text>
					)}
				</TextView>
				{type === "low" ? (
					<ButtonsView>
						<Button
							style={{
								width: "100%",
								backgroundColor: ColorV2.surface.primaryHard,
							}}
							onClick={props.onClose}
						>
							Entendido
						</Button>
					</ButtonsView>
				) : (
					<ButtonsView>
						<Button
							style={{ width: "100%" }}
							onClick={props.onSubmit}
						>
							Cambiar mi donación a{" "}
							{getAmountLabel(currencyPrice)}
						</Button>
						<Button
							style={{
								width: "100%",
								justifyContent: "center",
								fontWeight: 600,
								color: ColorV2.text.neutralHard,
							}}
							design="text"
							onClick={props.onClose}
						>
							Mantener mi donación actual
						</Button>
					</ButtonsView>
				)}
			</DataView>
		</Modal>
	);
};
export default UpdateSubscriptionModal;
export interface UpdateSubscriptionModalProps {
	isVisible: boolean;
	subscription: SubscriptionScheme;
	product: ProductScheme;
	onSubmit: () => void;
	onClose: () => void;
}
